import uuid from 'uuid/v1';
import * as R from 'ramda';
import moment from 'moment';

export const createSpecsheet = appSettings => ({ localId, customerId, sheetToCopy = {}, bowlerHand }) => {
  const newSpecSheetId = localId || uuid();
  const newSheet = R.pipe(
    R.merge({
      localId: newSpecSheetId,
      customer_id: customerId,
      spec_sheet_date: moment().format('YYYY MMMM D'),
      hand: bowlerHand,
      ball_grip: appSettings.default_ball_grip,
      thm_type: appSettings.default_thm_type,
      thm_insert_type: '',
      f1_grip_type: '',
      f2_grip_type: '',
      note: '',
    }),
    R.omit(['id'])
  )(sheetToCopy);

  if (R.keys(sheetToCopy).length === 0) {
    if (appSettings.spec_sheet_auto_fill_bridge) {
      if (newSheet.ball_grip === 'conventional') {
        newSheet.bridge = '3/8';
      } else if (newSheet.ball_grip === 'finger_tip') {
        newSheet.bridge = '1/4';
      }
    }

    if (appSettings.spec_sheet_auto_lateral_pitches) {
      if (newSheet.ball_grip === 'conventional') {
        newSheet.f1_lat = '1/4';
        newSheet.f2_lat = '5/8';
      } else if (newSheet.ball_grip === 'finger_tip') {
        newSheet.f1_lat = '3/8';
        newSheet.f2_lat = '1/2';
      }
    }
  }

  return newSheet;
};
